import {getClosest} from '../helpers/helpers'

export default class Player {
  constructor(
    options = {
      trigger: '.embed-container__overlay',
      activeClass: 'active',
      wrapper: '.embed-container--inline'
    }
  ){
    this.trigger = options.trigger
    this.embeds = Array.from(document.querySelectorAll(this.trigger))
    this.activeClass = options.activeClass
    this.wrapper = options.wrapper

    this.events();
  }

  events() {
    this.handleClick = this.handleClick.bind(this)
    this.embeds.forEach(el => el.addEventListener('click', this.handleClick))
  }

  handleClick(e){
    const target = e.target;

    parent = getClosest(target, this.wrapper);

    parent.classList.contains(this.activeClass) ? this.stopVideo(parent) : this.playVideo(parent)
  }

  playVideo(el){
    el.classList.add(this.activeClass)
    this.handleVideo(el, true);
  }

  stopVideo(el){
    el.classList.remove(this.activeClass)
    this.handleVideo(el, false);
  }

  handleVideo(element, play){
    const iframe = element.querySelector('iframe')
    if (iframe){
      const iframeContent = iframe.contentWindow
      const iframeCommand = JSON.stringify( {
        event: 'command',
        func: play ? 'playVideo' : 'pauseVideo'
      } )
      iframeContent.postMessage(iframeCommand, '*');
    }
  }
}